/**
 * @name CollectorDepositController
 * @description Controller for collector deposits
 * @param {type} $uibModalInstance Description
 * @param {type} appointment The appointment from the resolve
 * @param {type} project The project from the resolve
 */
function CollectorDepositController(
  $uibModalInstance,
  appointment,
  project
) {
  let vm = this;
  // Defaults
  vm.appointment = appointment;
  vm.project = project;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('CollectorDepositController', CollectorDepositController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/deposit/deposit.controller.js